import React, { useContext, useState, useRef } from 'react';
import { Container, Row, Col, Table, Spinner, Form, InputGroup, Button } from 'react-bootstrap';
import $ from 'jquery';
import ReactToPrint from "react-to-print";
import generatePDF from 'react-to-pdf';
import { AppContext } from '../App';


export const DetailReport = () => {
	const { getDetailReport, detailReport, detailReportLoad, getDate, getBill, setViewBillModal, downloadExcel } = useContext(AppContext);
	const [dateRange, setDateRange] = useState('');
	const tableRef = useRef(null);

	const getReport = (e) => {
		e.preventDefault();
		let start = e.target.start.value;
		let end = e.target.end.value;
		let staff = e.target.staff.value;
		let service = e.target.service.value;
		if (start !== "" && end !== "") {
			getDetailReport(start, end, staff, service);
			setDateRange(`report_detailed_from_${start}_to_${end}`);
		}
	}

	const formatExcel = () => {
		if (detailReport !== undefined && detailReport.bill_values !== undefined && Object.keys(detailReport.bill_values).length > 0) {
			let data = [];
			Object.keys(detailReport.bill_values).map(b_val => {
				const bill = detailReport.bill_values[b_val];
				let services = "";
				if (bill.bill_services) {
					Object.keys(bill.bill_services).map(s => {
						services += bill.bill_services[s].service_name + ", ";
					})
				}
				data.push({
					'Invoice': bill.bill_no,
					'Date': bill.close_date + ' ' + bill.close_time,
					'Services': services,
					'Created By': bill.token_created_by, // Note: Original code labels vary, mapping based on display logic
					'Created Time': bill.created_time,
					'Processed By': bill.token_processed_by,
					'Processed Time': bill.open_time,
					'Closed By': bill.token_closed_by ?? '-', //losed By': bill.token_closed_by,
					'Closed Time': bill.close_time,
					'Customer': bill.customer_name,
					'Phone': bill.customer_phone,
					'SC': parseFloat(bill.service_bill_total).toFixed(2),
					'TC': parseFloat(bill.transaction_bill_total).toFixed(2),
					'Total': parseFloat(bill.bill_total).toFixed(2)
				});
			});
			return data;
		}
	}

	return (
		<div className='container-fluid'>
			<div className='grid2by8 align-items-center justify-content-center p-2 bgp br-3 mb-3' >
				<div className='px-2'>
					{
						detailReportLoad ? (
							<div className="d-grid py-2">
								<span className="please-wait-spinner" ><Spinner animation="border" size="sm" /> Please wait...</span>
							</div>
						) : (
							<span className='text-white' >Detailed Invoice Report</span>
						)

					}
				</div>
				<Form onSubmit={getReport} >
					<Row>
						<Col xs={12} sm={4} md={2} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">From</InputGroup.Text>
								<Form.Control name="start" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={2} >
							<InputGroup className="br-3">
								<InputGroup.Text className="br-3" id="inputGroup-sizing-default">To</InputGroup.Text>
								<Form.Control name="end" type="date" defaultValue={getDate()} className="br-3" />
							</InputGroup>
						</Col>
						<Col xs={12} sm={4} md={3} >
							<Form.Select name="staff" className="shadow-none br-2">
								<option value="" >All staffs</option>
								{
									detailReport !== undefined ? (
										detailReport.users !== undefined ? (
											Object.keys(detailReport.users).length > 0 ? (
												Object.keys(detailReport.users).map((staff, staff_i) => (
													<option value={staff.substring(1)} key={`user_${staff_i}`} >{detailReport.users[staff].username}</option>
												))
											) : ''
										) : ''
									) : ''
								}
							</Form.Select>
						</Col>
						<Col xs={12} sm={4} md={3} >
							<Form.Select name="service" className="shadow-none br-2">
								<option value="" >All services</option>
								{
									detailReport !== undefined ? (
										detailReport.services !== undefined ? (
											Object.keys(detailReport.services).length > 0 ? (
												Object.keys(detailReport.services).map((staff, staff_i) => (
													<option value={staff.substring(1)} key={`serv_${staff_i}`} >{detailReport.services[staff].name}</option>
												))
											) : ''
										) : ''
									) : ''
								}
							</Form.Select>
						</Col>
						<Col xs={12} sm={4} md={2} className="d-grid" >
							<Button type="submit" className="btn-t1-r br-3" >Get Report</Button>
						</Col>
					</Row>
				</Form>
			</div>
			{
				detailReport !== undefined && detailReport.bill_values !== undefined && Object.keys(detailReport.bill_values).length > 0 ? (
					<div className='d-flex justify-content-end align-items-center mb-2 gap-2' >
						<span>Download</span>
						<Button className="br-1" onClick={() => {
							downloadExcel(formatExcel(), `${dateRange}.xlsx`);
						}} size='sm' variant='success' ><i className='bi bi-download' ></i> Excel</Button>
						<Button onClick={() => {
							$('.view-bill-link').addClass('hide');
							generatePDF(tableRef, { filename: `${dateRange}.pdf` });
							$('.view-bill-link').removeClass('hide');
						}} size='sm' className='br-1' variant='success' ><i className='bi bi-download' ></i> Pdf</Button>
						<ReactToPrint
							trigger={() => <Button className='br-1' variant='success' size='sm'><i className="bi bi-printer"></i> Print</Button>}
							content={() => tableRef.current}
							onBeforeGetContent={() => {
								return new Promise((resolve) => {
									$('.view-bill-link').addClass('hide');
									resolve();
								});
							}}
							onAfterPrint={() => {
								$('.view-bill-link').removeClass('hide');
							}}
						/>
					</div>
				) : null
			}
			<div ref={tableRef}>
				<Table bordered className="tbl-bg-blue" >
					<thead>
						<tr>
							<th><span className="tp2" >Invoice</span></th>
							<th className="tp2" ><span>Service</span></th>
							<th className="tp2" ><span>Times</span></th>
							<th className="tp2" ><span>Customer</span></th>
							<th className="text-end tp2" ><span>SC</span></th>
							<th className="text-end tp2" ><span>TC</span></th>
							<th className="text-end tp2" >Total</th>
						</tr>
					</thead>
					<tbody>
						{
							detailReport !== undefined ? (
								detailReport.bill_values !== undefined ? (
									Object.keys(detailReport.bill_values).length > 0 ? (
										Object.keys(detailReport.bill_values).map((b_val, b_i) => (
											<tr key={`b_val_${b_i}`} >
												<td>
													<div className='d-grid'>
														<div className='d-flex align-items-center' >
															<span onClick={() => {
																getBill(detailReport.bill_values[b_val].bill_no);
																setViewBillModal(true);
															}} className="view-bill-link" ><i className="bi bi-receipt"></i> Bill</span>
														</div>
														<span className="tp2" >Invoice : {detailReport.bill_values[b_val].bill_no}</span>
														<span className="tp2 f12" >{detailReport.bill_values[b_val].close_date}, {detailReport.bill_values[b_val].close_time}</span>
													</div>
												</td>
												<td>
													{
														detailReport.bill_values[b_val].bill_services !== undefined ? (
															Object.keys(detailReport.bill_values[b_val].bill_services).length > 0 ? (
																Object.keys(detailReport.bill_values[b_val].bill_services).map((bserv, bs_i) => (
																	<span className="tp2 d-grid" key={`bserv_${bs_i}`}  >{detailReport.bill_values[b_val].bill_services[bserv].service_name}</span>
																))
															) : ''
														) : ''
													}
												</td>
												<td>
													<div className="grid8by2 align-items-center justify-content-between bdrb2" >
														<span className="tp2 f14" >{`Created - ${detailReport.bill_values[b_val].token_created_by}`}</span>
														<div className='d-flex justify-content-end'>
															<span className="tp2 f14" >{detailReport.bill_values[b_val].created_time}</span>
														</div>
													</div>
													<div className="grid8by2 align-items-center justify-content-between bdrb2" >
														<span className="tp2 f14" >{`Processed - ${detailReport.bill_values[b_val].token_processed_by}`}</span>
														<div className='d-flex justify-content-end'>
															<span className="tp2 f14" >{detailReport.bill_values[b_val].open_time}</span>
														</div>
													</div>
													<div className="grid8by2 align-items-center justify-content-between bdrb2" >
														<span className="tp2 f14" >{`Closed - ${detailReport.bill_values[b_val].closed_by ?? ''}`}</span>
														<div className='d-flex justify-content-end'>
															<span className="tp2 f14" >{detailReport.bill_values[b_val].close_time}</span>
														</div>
													</div>
												</td>
												<td>
													<div className='d-grid'>
														<span className="tp2" >{detailReport.bill_values[b_val].customer_name}</span>
														<span className="tp2 f14" >{detailReport.bill_values[b_val].customer_phone}</span>
													</div>
												</td>
												<td className="tp2 text-end" >
													<span>{parseFloat(detailReport.bill_values[b_val].service_bill_total).toFixed(2)}</span>
												</td>
												<td className="tp2 text-end" >
													<span>{parseFloat(detailReport.bill_values[b_val].transaction_bill_total).toFixed(2)}</span>
												</td>
												<td className="tp2 text-end" >
													<span>{parseFloat(detailReport.bill_values[b_val].bill_total).toFixed(2)}</span>
												</td>
											</tr>
										))
									) : ''
								) : ''
							) : ''
						}
						{
							detailReport !== undefined ? (
								detailReport.main !== undefined ? (
									<tr>
										<td colSpan={4} className="text-end f18 bgy" ><span className='f20' >Total</span></td>
										<td className="text-end bgy"><span className='f20' >{parseFloat(detailReport.main.service_day_total).toFixed(2)}</span></td>
										<td className="text-end bgy"><span className='f20' >{parseFloat(detailReport.main.transaction_day_total).toFixed(2)}</span></td>
										<td className="text-end bgy"><span className='f20' >{parseFloat(detailReport.main.grand_day_total).toFixed(2)}</span></td>
									</tr>
								) : ''
							) : ''
						}
					</tbody>
				</Table>
			</div>
		</div>
	)
}